import { render, staticRenderFns } from "./Cms.vue?vue&type=template&id=354ad5e3"
import script from "./Cms.vue?vue&type=script&lang=ts"
export * from "./Cms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports